module.exports = __webpack_public_path__ + "img/doctor-2.82910c03.png";